export { default as ScrollableTableWrapper } from './ScrollableTableWrapper';
export type { ScrollableTableWrapperProps } from './ScrollableTableWrapper';
